import { render, staticRenderFns } from "./SearchResultProduct.vue?vue&type=template&id=a587d0d4&scoped=true&"
import script from "./SearchResultProduct.vue?vue&type=script&lang=ts&"
export * from "./SearchResultProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a587d0d4",
  null
  
)

export default component.exports